export default __webpack_public_path__ + "static/media/expert.0f27c706.png";